if (!customElements.get('quantity-picker')) {
  class QuantityPicker extends HTMLElement {
    constructor() {
      super();

      this.handleChange = this.onChange.bind(this);
    }

    connectedCallback() {
      this.addEventListener('change', this.handleChange);
      this.syncSelectedQuantity();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
    }

    get sectionRoot() {
      return this.closest('[id^="shopify-section-"]') || document;
    }

    get addToCartForms() {
      if (this.dataset.productFormId) {
        const formById = document.getElementById(this.dataset.productFormId);
        if (formById && this.sectionRoot.contains(formById)) return [formById];
      }

      return [...this.sectionRoot.querySelectorAll('form[action*="/cart/add"]')];
    }

    get selectedInput() {
      return this.querySelector('input[name="quantity-picker"]:checked')
        || this.querySelector('input[name="quantity-picker"]');
    }

    getQuantityValue(input) {
      const quantity = Number.parseInt(input?.value || input?.dataset.quantity, 10);
      return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
    }

    getFormQuantityInputs(form) {
      const directInputs = [...form.querySelectorAll('input[name="quantity"]')];
      const externalInputs = form.id
        ? [...this.sectionRoot.querySelectorAll(`input[name="quantity"][form="${form.id}"]`)]
        : [];
      const quantityInputs = [...new Set([...directInputs, ...externalInputs])];

      if (quantityInputs.length > 0) return quantityInputs;

      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'quantity';
      hiddenInput.value = '1';
      form.appendChild(hiddenInput);

      return [hiddenInput];
    }

    syncQuantityToForms(quantity) {
      this.addToCartForms.forEach((form) => {
        this.getFormQuantityInputs(form).forEach((input) => {
          input.value = String(quantity);
        });
      });
    }

    syncSelectedQuantity() {
      if (!this.selectedInput) return;
      this.syncQuantityToForms(this.getQuantityValue(this.selectedInput));
    }

    onChange(event) {
      const input = event.target.closest('input[name="quantity-picker"]');
      if (!input || !input.checked) return;

      this.syncQuantityToForms(this.getQuantityValue(input));
    }
  }

  customElements.define('quantity-picker', QuantityPicker);
}
